import type { FeedstockMonth } from "../types/feedstockTypes"

export const getMonthAverage = (month: FeedstockMonth, key: number) => {
  return month.dates.reduce((a, c) => {
    const value = c.values.find((kv) => kv.dimensionKey === key && kv.type == "Actual")

    return a + (value?.value || 0) / month.dates.length
  }, 0)
}
